module.exports = __webpack_public_path__ + "img/Metal038_1K_Color.67cdc58e.jpg";